<app-spinner [loading]="loading"></app-spinner>
<div style="padding:30px">
    <app-search (item)="callitem($event)"  (searchstr)="searchstr($event)"></app-search>
    <hr>
    <app-table-v2  *ngIf="data.length>0" [type]="2" [tcontent]="tcontent" [data]="data" (callback)="init_list()"> 
        <ng-template let-post #operation_dk>
            <div *ngIf="post.key == 'gg'">
                <a href="javascript:void(0)" title="觀看明細"  (click)="now = '1';target = post.val;detail()" data-toggle="modal" data-target=".bd-example-modal-xl">
                    <i style="margin: 0 10px 0 0;" class="fas fa-list-ul"></i>
                </a>
                <a href="javascript:void(0)" title="送/扣鑽"  (click)="now = '0';subnow = '0';target = post.val;" data-toggle="modal" data-target=".bd-example-modal-xl">
                    <i style="margin: 0 10px 0 0;" class="fas fa-wrench"></i>
                </a>   
            </div>
        </ng-template>
    </app-table-v2>
    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
</div>

<div 
    *ngIf="target"
    class="modal fade bd-example-modal-xl" tabindex="-1"
    role="dialog"  data-keyboard="false" data-backdrop="static" 
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{now == '0'?'鑽石發放':'觀看明細'}}</h4>
                <button type="button" id="close" class="close"  (click)="init_list()" data-dismiss="modal">&times;</button>
            </div>
  
            <div class="modal-body"> 
                <div *ngIf="now=='0'">
                    <ul class="nav nav-tabs" style="margin: 10px;">
                        <li *ngFor="let item of sub_list;let i = index" class="nav-item" (click)="subnow = item.id">
                            <span  style="cursor: pointer;" [ngClass]="subnow==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
                        </li>
                    </ul>

                    <div *ngIf="subnow=='0'">
                        <div>發送對象:{{target.name}}({{target.phone_num}})</div>
                        <div *ngIf="search_type == '1'">台幣:<input type="number"  class="form-control" style="width: 240px;"  [(ngModel)]="tw"></div>
                        <div>鑽石:<input type="number" class="form-control" style="width: 240px;"  [(ngModel)]="money"></div>
                        <div>描述:<input type="reason"  class="form-control" style="width: 240px;" [(ngModel)]="reason"></div>
                        類型:
                        <select class="form-control" style="width: 160px;display: inline-block;margin: 10px 0 10px 0;" [(ngModel)]="search_type">
                            <option default disabled>請選擇搜尋的類型</option>
                            <option *ngFor="let item of option_list" [ngValue]="item.id">{{item.name}}</option>
                        </select>
                        <span style="color:#ccc;font-size:8px" *ngIf="search_type=='5' || search_type=='6' || search_type=='9'">會自動變成扣款 金額不要填負值</span>
                        <div>
                            佐證圖:
                            <img loading="lazy" style="height: 80px" [src]="tmp_img_b64"  (click)="tmp_img_b64=''">
                            <div class="btn btn-info" style="position:relative;margin-left:10px;">
                                <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="target.fixid = -1;upload($event)" placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
                            </div>
                        </div>
                    </div>

                    <div *ngIf="trade_info && subnow=='1'" style="padding: 10px;">
                        <div class="user_edit_block">
                            <label class="col-sm-2 col-form-label">對象</label>
                            <app-search [nType]="1" (item)="callitemDetail($event)"></app-search>
                            <hr *ngIf="trade_info.list.length">
                        </div>
                        <div class="user_edit_block" *ngIf="trade_info.to_user_id && trade_info.to_user_id.length>0">
                            
                            <label class="col-sm-2 col-form-label">類型</label>
                            <select class="form-control" style="width: 160px;display: inline-block;margin-top: 10px;" [(ngModel)]="trade_info.trade_type" (change)="trade_btn_type(trade_info.trade_type)">
                                <option default disabled>請選擇類型</option>
                                <option *ngFor="let item of type_list" [ngValue]="item.id">{{item.name}}</option>
                            </select>

                        </div>

                        <div class="user_edit_block">
                            <label class="col-sm-2 col-form-label">交易雙方為</label>
                            <div style="display: flex;margin-left: 1.5%;"  *ngIf="target.profile_pic && trade_info.profile_pic && target.profile_pic.length && trade_info.profile_pic.length">
                                <div> 
                                    <button class="btn btn-info">
                                        <img loading="lazy" style="height: 80px;" [src]="target.profile_pic">
                                    </button>
                                    <p style="text-align: center;margin-top: 10%;"  *ngIf="trade_info.cust_from==0">付鑽</p>
                                    <p style="text-align: center;margin-top: 10%;"  *ngIf="trade_info.cust_from==1">收鑽</p>
                                </div>
                            <div style="margin-left: 3%;margin-right: 3%;">
                                <a 
                                    href="javascript:void(0)"
                                    (click)="trade_info.cust_from=1"><i  
                                    *ngIf="trade_info.cust_from==0"
                                    style="font-size: 40px;
                                    margin-top: 14px;" class="fas fa-arrow-right"></i>
                                </a>
                                <a  
                                    href="javascript:void(0)"
                                    (click)="trade_info.cust_from=0"><i 
                                    *ngIf="trade_info.cust_from==1"
                                    style="font-size: 40px;
                                    margin-top: 14px;" class="fas fa-arrow-left"></i>
                                </a>
                            </div>
                            <div> 
                                <button  *ngIf="trade_info.profile_pic && trade_info.profile_pic.length>0"class="btn btn-info">
                                    <img loading="lazy" style="height: 80px;" [src]="trade_info.profile_pic">
                                </button>
                                <p style="text-align: center;margin-top: 10%;"  *ngIf="trade_info.cust_from==1">付鑽</p>
                                <p style="text-align: center;margin-top: 10%;"  *ngIf="trade_info.cust_from==0">收鑽</p>
                            </div>
                        </div>
                    </div>
                    <div class="user_edit_block">
                        <label class="col-sm-2 col-form-label">鑽石數</label>
                        <input type="number" class="form-control" style="width: 180px;display: inline;" 
                               [(ngModel)]="money" 
                               (ngModelChange)="validateMoney()" 
                               min="1">
                    </div>

                    <div class="user_edit_block">
                        <label class="col-sm-2 col-form-label">描述</label>
                        <textarea class="form-control" style="width: 480px;display: inline;" [(ngModel)]="reason"></textarea>
                    </div>

                    <div class="user_edit_block">
                        <label class="col-sm-2 col-form-label">佐證圖</label>
                        <img loading="lazy" style="height: 80px" [src]="tmp_img_b64"  (click)="tmp_img_b64=''">
                        <div class="btn btn-info" style="position:relative;margin-left:10px;">
                            <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="target.fixid = -1;upload($event)" placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
                        </div>
                    </div>
           
                </div>
            </div>
            <div  *ngIf="now=='1'" style="height: 70vh;overflow:auto">
                <table class="modal-body">
                    <thead>
                        <tr style="border: solid #eee 2px; border-radius: 5px; margin-bottom: 5px; padding: 10px;">
                            <th style="width:5%">贈送者</th>
                            <th style="width:5%">類型</th>       
                            <th style="width:5%">鑽石數</th>
                            <th style="width:5%">台幣</th>
                            <th style="width:5%">原因</th>
                            <th style="width:5%">日期</th>
                            <th style="width:5%">佐證圖</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of detaildata; let key = index"  style="border: solid #eee 2px; border-radius: 5px; margin-bottom: 5px; padding: 10px;">
                            <td>
                                <span class="{{item.type==1 && item.pic.length == 0 ?'red':'black'}}">{{item.nickname}}</span>
                            </td>
                            <!-- <td>{{show[item.type]}}</td> -->
                            <td>
                                <select class="form-control" style="width: 160px;display: inline-block;margin-top: 10px;" [(ngModel)]="item.type" (change)="item.money=item.type==1?item.money:0;up_dt(item.id,item.type,item.money)">
                                    <option default disabled>請選擇搜尋的類型</option>
                                    <option *ngFor="let item of option_list" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                            </td>
                            <td>{{item.diamond}}</td>
                            <td>
                                <input type="number" class="form-control" style="width: 90px;" [(ngModel)]="item.money" (keyup.enter)="up_dt(item.id,item.type,item.money)">
                            </td>
                            <td>{{item.des}}</td>
                            <td>{{item.create_dt}}</td>
                            <td>
                                <img loading="lazy" *ngIf="item.pic.length>0 && power*1 < 5" style="height: 80px" [src]="item.pic" >
                                <img loading="lazy" *ngIf="item.pic.length>0 && power*1==5" style="height: 80px" [src]="item.pic"  (click)="target.fixid = item.id;adjust_pic(-1)">
                                <div *ngIf="item.pic.length==0"  class="btn btn-info" style="position:relative;margin-left:10px;">
                                    <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="target.fixid = item.id;upload($event)" placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button"  *ngIf="(subnow == '1' && money > 0 && trade_info.to_user_id.length > 0) || (subnow == '0')"  (click)="send_it()"  class="btn btn-info"  data-dismiss="modal">
                    送出
                </button>
        
                <button type="button" *ngIf="subnow == '1' && money <= 0"  (click)="alert()" class="btn btn-secondary">
                    送出
                </button>
                <button type="button"  (click)="init_list()" class="btn btn-danger" data-dismiss="modal">關閉</button>
            </div>
        </div>
    </div>
</div>
</div>







